const PLACEHOLDER = /^(?:write\b.*(?:here|text|paragraph)|lorem ipsum\b.*|(?:tbd|n\/a|no information available|ingen information|(?:\[|<)?placeholder(?:\]|>)?))\.?$/i;

export function hasRenderableSectionBody(value) {
  if (typeof value !== "string") return false;
  const text = value
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, " ")
    .replace(/<h[1-6]\b[^>]*>[\s\S]*?<\/h[1-6]\s*>/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;|&#160;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
  return !!text && !PLACEHOLDER.test(text);
}

function cloneRowWithItems(row, active, seen) {
  return {
    ...row,
    cells: (row.cells || []).map((cell) => ({
      ...cell,
      items: (cell.items || []).filter((item) => {
        if (item.type !== "section") return true;
        const id = String(item.sectionId || "");
        if (!active.has(id) || seen.has(id)) return false;
        seen.add(id);
        return true;
      }).map((item) => ({ ...item })),
    })).filter((cell) => cell.items.length),
  };
}

export function composePresentationRows(templateRows, contentSections) {
  const content = contentSections && typeof contentSections === "object" ? contentSections : {};
  const active = new Set(Object.entries(content)
    .filter(([, body]) => hasRenderableSectionBody(body))
    .map(([id]) => String(id)));
  const unsupported = new Set();
  for (const row of templateRows || []) {
    for (const cell of row.cells || []) {
      for (const item of cell.items || []) {
        if (item.type === "section" && item.unsupported === true && item.sectionId) {
          unsupported.add(String(item.sectionId));
        }
      }
    }
  }
  unsupported.forEach((id) => active.delete(id));

  const seen = new Set();
  const rows = [];
  for (const row of templateRows || []) {
    if (row.kind === "pagebreak") {
      rows.push({ ...row });
      continue;
    }
    if (row.kind !== "structure") {
      rows.push({ ...row });
      continue;
    }
    const filtered = cloneRowWithItems(row, active, seen);
    if (filtered.cells?.length) rows.push(filtered);
  }

  // A template may style/order its slots, but omitted content receives a
  // neutral section slot instead of being lost.
  for (const id of active) {
    if (seen.has(id)) continue;
    seen.add(id);
    rows.push({ kind: "structure", layout: "1col", cells: [{
      items: [{ type: "section", sectionId: id }],
    }] });
  }

  const compact = [];
  let pendingBreak = false;
  for (const row of rows) {
    if (row.kind === "pagebreak") {
      pendingBreak = compact.length > 0;
      continue;
    }
    if (pendingBreak && compact.length && row.kind !== "pagebreak") {
      compact.push({ kind: "pagebreak" });
    }
    pendingBreak = false;
    compact.push(row);
  }
  while (compact[compact.length - 1]?.kind === "pagebreak") compact.pop();
  return compact;
}
